<template lang="pug">
  .up-down
    template(v-for="(available, direction) in directions")
      button.move-btn(@click="$emit(direction)" :class="[direction]" :disabled="!available")
        Icon(name="angle-down" style="cursor: inherit")
</template>

<script>
export default {
  name: 'BtnUpDown',
  props: {
    directions: {
      type: Object,
      default() {
        return { up: true, down: true };
      },
      validator(value) {
        return Object.keys(value).length === 2
          && typeof value.up === 'boolean'
          && typeof value.down === 'boolean';
      },
    },
  },
};
</script>

<style scoped lang="scss">
 .up-down {
   display: flex;
   gap: 8px;
 }

 .move-btn {
   width: 21px;
   height: 23px;
   display: flex;
   justify-content: center;
   align-items: center;
   opacity: .5;
   border: 1px solid #92A0B0;
   border-radius: 4px;
   transition: opacity .1s linear;
   background: transparent;
   cursor: pointer;

   &:not([disabled]):hover {
     opacity: 1;
   }

   &.down svg {
     margin-top: 1px;
   }

   &.up svg {
     transform: rotate(180deg);
   }
 }
</style>
